// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileDropdown_root__aa_j1"};